import BaseModel from '../base/BaseModel.model';
import { CurriculumLevel } from '@/enums/curriculumLevel';
export default class UserLanguage extends BaseModel {
    public userId?: number;
    public curriculumUserId?: number;
    public language?:  string;
    public readingLevel?: CurriculumLevel | null;
    public writingLevel?: CurriculumLevel | null;
    public speechLevel?: CurriculumLevel | null;
    public languagueDescription?: string;
    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.curriculumUserId = undefined;
        this.language = "";
        this.readingLevel = null;
        this.writingLevel = null;
        this.speechLevel = null;
        this.languagueDescription = "";
    }
}